module.exports = __webpack_public_path__ + "img/icon-time.6a27afbe.svg";